import { render, staticRenderFns } from "./kf-video.vue?vue&type=template&id=354038c3"
import script from "./kf-video.vue?vue&type=script&lang=js"
export * from "./kf-video.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports